import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputPhoneComponent } from './input-phone.component';



@NgModule({
  declarations: [
    InputPhoneComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    InputPhoneComponent
  ]
})
export class InputPhoneModule { }
